'use strict';

import Swiper from 'swiper';

const SELECTOR = '.js-scroller';

export function initialiseElement(element) {
    const scrollerElement = element.querySelector('.swiper-container');
    const initOnMobile = element.dataset.mobile === 'true';

    const mq = window.matchMedia('(max-width: 928px)');

    let scroller;

    const settings = {
        slidesPerView: 'auto',
        freeMode: true,
        simulateTouch: false,
        mousewheel: {
            releaseOnEdges: true,
            forceToAxis: true,
            invert: true,
            sensitivity: .8
        },
        navigation: {
            nextEl: element.querySelector('.scroller-next'),
            prevEl: element.querySelector('.scroller-prev')
        },
        observer: true
    };

    function createSwiper() {
        scroller = new Swiper(scrollerElement, settings);
    }

    function destroySwiper() {
        if (scroller) {
            scroller.destroy(true, true);
            scroller = null;
        }
    }

    if (mq.matches ? initOnMobile : true) {
        createSwiper();
    }

    function loadScroller(event) {
        destroySwiper();
        if (event.matches ? initOnMobile : true) {
            createSwiper();
        }
    }

    mq.addListener(loadScroller);

}

export function init() {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}

export default {
    init,
    initialiseElement
}
